import { StatusUnionType } from '@api';

type GetColorReturnType = {
  backgroundColor: string;
  textColor: string;
};

export const getColor = (status: StatusUnionType): GetColorReturnType => {
  let backgroundColor = '';
  let textColor = '';

  switch (status) {
    case 'CONFIRMED':
      backgroundColor = '#C7F5D9';
      textColor = '#0C4121';
      break;
    case 'IN_PREPARATION':
      backgroundColor = '#CFE1FD';
      textColor = '#0A47A9';
      break;
    case 'DECLINED':
      backgroundColor = '#FDD9DE';
      textColor = '#7A0619';
      break;
    case 'POSTPONED':
      backgroundColor = '#FFEBC2';
      textColor = '#453007';
      break;
    case 'CANCELLED':
      backgroundColor = '#FDD9DE';
      textColor = '#7A0619';
      break;
  }
  return { backgroundColor, textColor };
};
